/**
 * Styled Components - Created by david on 10/04/18.
 */
import styled from 'styled-components'
import Search from 'antd/lib/auto-complete'
import Button from 'antd/lib/button'
import InputComponent from 'antd/lib/input'
import { RED, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
   background-color: #222;
 `

export const Text = styled.div`
   color: #fff;
 `

export const Title = styled.div`
   color: #5f6062;
   font-size: 18px;
   font-weight: 600;
   line-height: 25px;
 `

export const List = styled.div`
   padding-top: 22px;
   min-height: 128px;
   overflow: auto;
   white-space: nowrap;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   width: 100%;
   align-items: flex-start;
 
   @media (min-width: 320px) and (max-width: 480px) {
     height: auto;
   }
 `

export const ErrorContainer = styled.div`
   display: flex;
   flex: 1;
   height: 60vh;
   justify-content: center;
   align-items: center;
   flex-direction: column;
 `

export const ErrorTitle = styled.div`
   color: #5f6062;
   font-size: 16px;
   font-weight: 600;
   line-height: 22px;
 `

export const Message = styled.div`
   margin-top: 16px;
   font-size: 16px;
   line-height: 23px;
   text-align: center;
 `

export const modalStyle = { paddingBottom: '96px' }

export const bodyStyle = { padding: '12px' }

export const PaginationRow = styled.div`
   text-align: right;
   padding-right: 2%;
   margin-top: 10px;
 
   @media (min-width: 320px) and (max-width: 480px) {
     padding: 0;
     text-align: center;
   }
 `

export const NotFound = styled.div`
   font-size: 18px;
 `

export const StyledSearch = styled(Search)`
   width: 100%;
   .ant-select-selection__rendered {
     line-height: 50px !important;
   }
 `

export const Input = styled(InputComponent)`
   border-radius: 0;
   margin-top: 6px;
 `

export const SearchButton = styled(Button)`
   height: 100%;
   border: none;
   width: 35px;
 `

export const TopSection = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
 `

export const SelectAllDiv = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   margin-right: 6px;
   margin-left: 18px;
   height: 50px;
   min-width: 50px;
 `

export const SelectAllLabel = styled.div`
   white-space: nowrap;
   padding: 11px 12px;
   border: 1px solid ${RED};
   border-radius: 3px;
   color: ${RED};
   font-size: 12px;
   transition: all .25s;
   &:hover {
     cursor: pointer;
     background: ${RED};
     color: ${WHITE};
   }
 `

export const TopLabels = styled.div`
  display: flex;
  align-items: center;
`

export const AdviseLabel = styled.div`
  margin-right: 30px;
  font-size: 12px;
`

export const TotalAmountsIcon = styled(Icon)`
  margin-right: 10px;
  color: ${RED};
`

export const TotalAmounts = styled.div`
  margin-right: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 10px;
`

export const ActionButtons = styled.div`
  display: inline-flex;
  margin-right: 42px;
`

export const AddButton = styled.div`
  color: #fff;
  background-color: #e61737;
  border-color: #e61737;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  width: fit-content;
  padding: 8px 14px;
  border-radius: 5px;
  margin-left: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CancelButton = styled.div`
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border: 1px solid #d9d9d9;
  width: fit-content;
  padding: 8px 12px;
  border-radius: 5px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/InlineModal/styledComponents.tsx